import alertService from '../services/AlertService';

interface ApiError extends Error {
  reason: {
    id: string;
  };
}

export const handleError = (error: Error) => {
  console.error(error);
  alertService.showError();
};

export const isNoEffect = (error: ApiError): boolean => {
  return error?.reason?.id === 'NoEffect';
};
